<template>
  <div class="container">
    <el-pagination
      background
      layout="total, prev, pager, next"
      :total="total"
      :page-count="pageCount"
      :current-page="currentPage"
      @current-change="pageChanged"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 0,
    },
    pageCount: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    pageChanged(e) {
      this.$emit("pageChanged", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: right;

  .el-pagination {
    padding: 15px 0px 0px;
  }
}
</style>
